import { useParams } from "react-router-dom"
import { Container, Row, Col, Button, Stack } from "react-bootstrap"
import { useDeleteIntegrationMutation, useGetIntegrationByIdQuery } from "../../../services/bClientApi"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"

export default function DeleteIntegrationPage() {
    const { integrationId = '' } = useParams()

    const {
        data: integrationData,
        error,
        isLoading
    } = useGetIntegrationByIdQuery(integrationId, { skip: !integrationId })

    const [
        deleteIntegration,
        {
            isLoading: deleteIsLoading,
            error: deleteError
        }
    ] = useDeleteIntegrationMutation()

    const dispatch = useAppDispatch()

    const handleDelete = async () => {
        try {
            await deleteIntegration(integrationId).unwrap()
            dispatch(navigateTo('/integrations'))
        } catch (err) {
            console.error('Failed to delete integration:', err)
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Integration</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {integrationId && integrationData && integrationData._id && !isLoading && (
                        <div>
                            <div className="mb-4">
                                <h4>Integration to Delete</h4>
                                <div className="border rounded p-3">
                                    <Row className="mb-2">
                                        <Col xs={4}><strong>Provider</strong></Col>
                                        <Col xs={8}>{integrationData.provider}</Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs={4}><strong>Entity Type</strong></Col>
                                        <Col xs={8}>{integrationData.entityType}</Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs={4}><strong>Entity ID</strong></Col>
                                        <Col xs={8}><code>{integrationData.entityId}</code></Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col xs={4}><strong>Primary External ID</strong></Col>
                                        <Col xs={8}><code>{integrationData.primaryExternalId}</code></Col>
                                    </Row>
                                </div>
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this integration? This action cannot be undone.
                                </div>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/integration/${integrationId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={handleDelete}
                                        disabled={deleteIsLoading}
                                    >
                                        {deleteIsLoading ? 'Deleting...' : 'Delete Integration'}
                                    </Button>
                                </div>
                            </Stack>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
